import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
} from "@component/dialog";
import { Job } from "@type/job";
import { getCookie } from "@util/cookie";
import ApplyForm from "@container/apply-form";
import { convertCurrency } from "@util/currency";
import { mapJobRateFrequency } from "@constant/app";

interface Props {
    open: boolean;
    onClose: (open: boolean) => void;
    job: Job
    onReloadCurrentUser: (onGetCV: (user_id: string, email: string, name: string) => void) => void
    onJobApplied: (isApplied: boolean) => void
    isJobApplied?: boolean
}

export default function DialogApplyNow(props: Props) {
    const token = getCookie("authToken");

    return (
        <Dialog open={props.open} onOpenChange={props.onClose}>
            <DialogContent className="sm:max-w-md">
                <DialogHeader>
                    <DialogTitle className="text-left">
                        <div className="space-y-1">
                            <h2 className="text-xl font-bold">
                                {((props.job.min_rate || 0) === 0 || (props.job.max_rate || 0) === 0) && props.job.fixed_rate === 0 ? "Competitive compensation (DOE)" : (
                                    <>
                                        {(props.job.min_rate && props.job.max_rate) ? `${convertCurrency(props.job.min_rate, props.job.rate_currency || "USD")}-${convertCurrency(props.job.max_rate, props.job.rate_currency || "USD")}` : convertCurrency(props.job.fixed_rate, props.job.rate_currency || "USD")}
                                        {` per ${mapJobRateFrequency[props.job.pay_rate_frequency as keyof typeof mapJobRateFrequency] || ""}`}
                                    </>
                                )}
                            </h2>
                            <p className="text-black font-medium">{props.job.job_type}</p>
                        </div>
                    </DialogTitle>
                </DialogHeader>

                <div className="space-y-4">
                    <ApplyForm
                        isGuestMode={!token}
                        isQuickApply={props.job.company_is_quick_apply || false}
                        job={props.job}
                        onReloadCurrentUser={props.onReloadCurrentUser}
                        onJobApplied={props.onJobApplied}
                    />
                </div>
            </DialogContent>
        </Dialog>
    );
}
